export abstract class ArrayHelper {
  public static distinct(value: string, index: number, self: string[]) {
    return self.indexOf(value) === index;
  }
}
